// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3p14e","title":"styles_title__2IETa"};